(function () {
  'use strict';

  function mount(root) {
    var tabsEl = root.querySelector('.ga-policy__tabs');
    var selectEl = root.querySelector('.ga-policy__select');
    var panels = Array.prototype.slice.call(root.querySelectorAll('.ga-policy__panel'));
    if (!tabsEl || !selectEl || !panels.length) return;

    function hasPanel(id) {
      return panels.some(function (panel) { return panel.dataset.id === id; });
    }

    function activate(id, updateHash) {
      if (!hasPanel(id)) id = panels[0].dataset.id;

      tabsEl.querySelectorAll('.ga-policy__tab').forEach(function (button) {
        var active = button.dataset.id === id;
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        if (panel.dataset.id === id) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      if (selectEl.value !== id) selectEl.value = id;

      if (updateHash && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
    }

    tabsEl.addEventListener('click', function (event) {
      var button = event.target.closest('.ga-policy__tab');
      if (button && button.dataset.id) activate(button.dataset.id, true);
    });

    tabsEl.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var tabs = Array.prototype.slice.call(tabsEl.querySelectorAll('.ga-policy__tab'));
      var current = tabs.indexOf(document.activeElement);
      if (current < 0) return;
      event.preventDefault();
      var direction = event.key === 'ArrowDown' ? 1 : -1;
      var next = (current + direction + tabs.length) % tabs.length;
      tabs[next].focus();
      activate(tabs[next].dataset.id, true);
    });

    selectEl.addEventListener('change', function (event) {
      activate(event.target.value, true);
    });

    window.addEventListener('hashchange', function () {
      activate(window.location.hash.slice(1), false);
    });

    activate(window.location.hash.slice(1), false);
  }

  function init() {
    document.querySelectorAll('[data-policy]').forEach(function (root) {
      if (root.dataset.policyMounted === '1') return;
      root.dataset.policyMounted = '1';
      mount(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
